"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _useHoverCycle = _interopRequireWildcard(require("web/shared/icons/useHoverCycle"));
var _AnchoredOverlay = _interopRequireDefault(require("web/shared/components/AnchoredOverlay"));
var _ConfirmModal = _interopRequireDefault(require("web/shared/components/ConfirmModal"));
var _ImageCandidateCard = _interopRequireDefault(require("web/shared/imageCandidates/ImageCandidateCard"));
var _ImageCandidateIconButton = _interopRequireDefault(require("web/shared/imageCandidates/ImageCandidateIconButton"));
var _ImageCandidateFullScreen = _interopRequireDefault(require("web/shared/imageCandidates/ImageCandidateFullScreen"));
var _imageCandidateWording = require("web/shared/imageCandidates/imageCandidateWording");
var _ImageCandidateStrip = require("web/shared/imageCandidates/ImageCandidateStrip.styles");
var _toast = require("web/shared/utils/toast");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A strip of uploaded pictures for one thing, with the one shown outlined in
* the accent, and the controls that change that. It stands at the height it is
* given and scrolls sideways; the add button is an end cap off the scroll, and
* the whole frame takes a dropped image.
*
* The candidates, the loading and busy states, the refusal to show, and
* the three actions are the caller's, each action answering whether it
* went through; the words come through the wording context, provided
* here for every control inside.
*/ // What the file picker offers first. The server decides from the bytes, so
// this is a convenience rather than the check.
const ACCEPTED_FILES = ".png,.jpg,.jpeg,.webp,image/png,image/jpeg,image/webp"; // How long a just-chosen card keeps its arrival after the server agrees,
// which is the ring's length.
const CHOSEN_SETTLE_MS = 700;
function ImageCandidateStrip(props) {
  var _candidates$find;
  const candidates = props.candidates,
    loading = props.loading,
    busy = props.busy,
    wording = props.wording,
    onChoose = props.onChoose;
  const _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    pendingDelete = _useState2[0],
    setPendingDelete = _useState2[1]; // The candidate shown full screen, by id so it tracks the row through a
  // reload rather than holding a stale copy, and where on the strip it was
  // opened from.
  const _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    viewed = _useState4[0],
    setViewed = _useState4[1]; // The candidate just tapped to be chosen, by id, held from the tap until
  // a moment after the server agrees so the card's arrival can play out.
  const _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    choosingId = _useState6[0],
    setChoosingId = _useState6[1];
  const fileInput = (0, _react.useRef)(null);
  const strip = (0, _react.useRef)(null); // Whether the strip is scrolled past its start at all, which is when a
  // way back to it is offered.
  const _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    scrolled = _useState8[0],
    setScrolled = _useState8[1];
  const _useState9 = (0, _react.useState)(null),
    _useState0 = (0, _slicedToArray2.default)(_useState9, 2),
    addButton = _useState0[0],
    setAddButton = _useState0[1];
  const _useState1 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2.default)(_useState1, 2),
    addPointed = _useState10[0],
    setAddPointed = _useState10[1];
  const plusProgress = (0, _useHoverCycle.default)(addPointed && !busy, _useHoverCycle.GLYPH_CYCLE_MS);
  const choose = (0, _react.useCallback)(async candidateId => {
    setChoosingId(candidateId);
    const chosen = await onChoose(candidateId);
    if (chosen) {
      // Said only once the server holds it, so the toast never claims
      // what the row will contradict.
      (0, _toast.showToast)(wording.nowChosen); // The tap's own mark lingers long enough for its ring to finish
      // before the row takes over.
      await new Promise(resolve => setTimeout(resolve, CHOSEN_SETTLE_MS));
    }
    setChoosingId(held => held === candidateId ? null : held);
  }, [onChoose, wording.nowChosen]);
  const onFilePicked = event => {
    var _event$currentTarget$;
    const file = (_event$currentTarget$ = event.currentTarget.files) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$[0]; // Clearing the input lets the same file be picked twice in a row, which
    // a curator re-uploading after a refusal does.
    event.currentTarget.value = "";
    if (file != null) {
      void props.onUpload(file);
    }
  }; // Whether a file is being held over the frame. Counted rather than
  // flagged: the drag leaves and re-enters every child it crosses, and a
  // flag would flicker off between a card and the strip.
  const _useState11 = (0, _react.useState)(0),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    dragDepth = _useState12[0],
    setDragDepth = _useState12[1];
  const dragging = dragDepth > 0;
  const holdsFile = event => Array.from(event.dataTransfer.types).includes("Files");
  const onDragEnter = event => {
    if (!holdsFile(event)) {
      return;
    }
    event.preventDefault();
    setDragDepth(depth => depth + 1);
  };
  const onDragOver = event => {
    if (!holdsFile(event)) {
      return;
    } // Claiming the drag is what makes the drop land here rather than open
    // the file in the tab.
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
  };
  const onDragLeave = event => {
    if (!holdsFile(event)) {
      return;
    }
    setDragDepth(depth => Math.max(0, depth - 1));
  };
  const onDrop = event => {
    if (!holdsFile(event)) {
      return;
    }
    event.preventDefault();
    setDragDepth(0);
    const file = event.dataTransfer.files[0];
    if (file != null && !busy && !loading) {
      void props.onUpload(file);
    }
  };
  const only = props.lastIsProtected && candidates.length === 1;
  const empty = !loading && candidates.length === 0;
  const viewedCandidate = viewed == null ? null : (_candidates$find = candidates.find(candidate => candidate.id === viewed.id)) !== null && _candidates$find !== void 0 ? _candidates$find : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_imageCandidateWording.ImageCandidateWordingProvider, {
    value: wording,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ref: fileInput,
      type: "file",
      accept: ACCEPTED_FILES,
      hidden: true,
      onChange: onFilePicked,
      "data-testid": "".concat(props.testIdPrefix, "-file-input")
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateStrip.styles.frame, dragging && _ImageCandidateStrip.styles.frameDropping)), {}, {
      style: {
        "--strip-height": props.height
      },
      onDragEnter: onDragEnter,
      onDragOver: onDragOver,
      onDragLeave: onDragLeave,
      onDrop: onDrop,
      "data-testid": "".concat(props.testIdPrefix, "-drop-zone"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({
        "aria-hidden": "true"
      }, stylex.props(_ImageCandidateStrip.styles.dropNote, dragging && _ImageCandidateStrip.styles.dropNoteShown)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateStrip.styles.dropNoteRing)), {}, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            name: "plus",
            size: "m"
          })
        })), wording.dropNote]
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", (0, _objectSpread2.default)((0, _objectSpread2.default)({
        ref: strip
      }, stylex.props(_ImageCandidateStrip.styles.strip, empty && _ImageCandidateStrip.styles.stripEmpty)), {}, {
        "aria-label": wording.listLabel,
        onScroll: event => {
          setScrolled(event.currentTarget.scrollLeft > 0);
        },
        children: [loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("li", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateStrip.styles.stripNote)), {}, {
          children: wording.loadingNote
        })) : null, empty ? /*#__PURE__*/(0, _jsxRuntime.jsx)("li", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateStrip.styles.stripNote)), {}, {
          children: wording.emptyNote
        })) : null, candidates.map(candidate => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageCandidateCard.default, {
          candidate: candidate,
          only: only,
          choosing: choosingId === candidate.id,
          busy: busy,
          onChoose: () => choose(candidate.id),
          onView: from => setViewed({
            id: candidate.id,
            from
          }),
          onDelete: () => setPendingDelete(candidate)
        }, candidate.id))]
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateStrip.styles.backToStart, scrolled && _ImageCandidateStrip.styles.backToStartShown)), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageCandidateIconButton.default, {
          name: "chevron-left",
          label: "Back to the first picture",
          title: "Back to the start",
          kind: "view",
          motion: "nudge",
          blocked: false,
          disabled: !scrolled,
          onPress: () => {
            var _strip$current;
            (_strip$current = strip.current) === null || _strip$current === void 0 ? void 0 : _strip$current.scrollTo({
              left: 0,
              behavior: "smooth"
            });
          }
        })
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
        ref: setAddButton,
        type: "button",
        "aria-label": wording.uploadLabel,
        disabled: busy || loading,
        onClick: () => {
          var _fileInput$current;
          (_fileInput$current = fileInput.current) === null || _fileInput$current === void 0 ? void 0 : _fileInput$current.click();
        },
        onMouseEnter: () => setAddPointed(true),
        onMouseLeave: () => setAddPointed(false),
        onFocus: () => setAddPointed(true),
        onBlur: () => setAddPointed(false)
      }, stylex.props(_ImageCandidateStrip.styles.addSlot)), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateStrip.styles.addRing)), {}, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            name: "plus",
            size: "m",
            progress: plusProgress
          })
        }))
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AnchoredOverlay.default, {
        anchor: addPointed ? addButton : null,
        placement: "above",
        onDismiss: null,
        role: "tooltip",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateStrip.styles.tip)), {}, {
          children: busy ? "Working…" : wording.uploadLabel
        }))
      })]
    })), props.error !== "" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateStrip.styles.error)), {}, {
      role: "alert",
      children: props.error
    })) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageCandidateFullScreen.default, {
      request: viewed != null && viewedCandidate != null ? {
        candidate: viewedCandidate,
        from: viewed.from
      } : null,
      only: only,
      choosing: viewedCandidate != null && choosingId === viewedCandidate.id,
      busy: busy,
      onChoose: () => {
        if (viewedCandidate != null) {
          choose(viewedCandidate.id);
        }
      },
      onDelete: () => setPendingDelete(viewedCandidate),
      onClose: () => setViewed(null)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfirmModal.default, {
      open: pendingDelete != null,
      title: wording.deleteDialogTitle,
      message: pendingDelete != null ? props.deleteMessage(pendingDelete) : "",
      confirmLabel: wording.deleteConfirmLabel,
      busy: busy,
      onConfirm: () => {
        const candidate = pendingDelete;
        if (candidate == null) {
          return;
        }
        void props.onDelete(candidate.id).then(deleted => {
          if (deleted) {
            setPendingDelete(null);
            setViewed(null);
          }
        });
      },
      onCancel: () => setPendingDelete(null)
    })]
  });
}
var _default = exports.default = ImageCandidateStrip;